import * as mutationsType from './mutationsType'
export default {
  //保存admin用户信息
  saveAdminUserInfo ({ commit }, adminUserInfo) {
    commit(mutationsType.RECEIVE_ADMIN_USER_INFO, { adminUserInfo })
  },
  //清除admin用户信息
  clearAdminUserInfo ({ commit }) {
    commit(mutationsType.CLEAR_ADMIN_USER_INFO)
  },
  //更新后台用户token信息
  updateAdminToken ({ commit }, token) {
    commit(mutationsType.UPDATE_WEB_TOKEN, { token })
  },
}
